import { Component, OnDestroy, OnInit } from '@angular/core';
import { AutenticacaoService } from 'app/services/autenticacao.service';
import { AlterarSenhaModalService } from 'app/modals/alterar-senha-modal/alterar-senha-modal.service';
import { BoasVindasModalService } from 'app/modals/boas-vindas-modal/boas-vindas-modal.service';
import { OnboardingService } from 'app/services/onboarding.service';
import { StorageService } from 'app/services/storage.service';
import { KeysStorage } from 'app/comum/keys-storage';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss'],
  standalone: false
})
export class HomeComponent implements OnInit, OnDestroy {

  constructor(
    private autenticacaoService: AutenticacaoService,
    private alterarSenhaModalService: AlterarSenhaModalService,
    private boasVindasModalService: BoasVindasModalService,
    private onboardingService: OnboardingService,
    private storageService: StorageService,
  ) { }

  ngOnInit() {
    this.verificarPrimeiroAcesso();
  }

  ngOnDestroy() { }

  private verificarPrimeiroAcesso() {
    if (this.autenticacaoService.isPrimeiroAcesso()) {
      this.alterarSenhaModalService.abrirModal().then(() => {
        this.verificarBoasVindas();
      }).catch(() => {
        this.verificarBoasVindas();
      });
    } else {
      this.verificarBoasVindas();
    }
  }

  private async verificarBoasVindas() {
    const jaExibido = this.storageService.get(KeysStorage.boasVindasExibido());
    if (jaExibido) return;

    try {
      const status = await this.onboardingService.obterStatus();
      if (status.concluido) {
        this.storageService.set('true', KeysStorage.boasVindasExibido());
        return;
      }
    } catch { }

    this.boasVindasModalService.abrirModal().then(() => {
      this.storageService.set('true', KeysStorage.boasVindasExibido());
    }).catch(() => {
      this.storageService.set('true', KeysStorage.boasVindasExibido());
    });
  }

}
